// extracted by mini-css-extract-plugin
export default {"wrapper":"VS-z"};